var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgForbidden = function SvgForbidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0377 13.0372L16.0007 16.0002M16.0007 16.0002L18.9636 18.9631M16.0007 16.0002L18.9636 13.0372M16.0007 16.0002L13.0377 18.9631M26.6673 16.0002C26.6673 21.8912 21.8917 26.6668 16.0007 26.6668C10.1096 26.6668 5.33398 21.8912 5.33398 16.0002C5.33398 10.1091 10.1096 5.3335 16.0007 5.3335C21.8917 5.3335 26.6673 10.1091 26.6673 16.0002Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgForbidden;